// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1QFOE","subheader":"ReorderModal_subheader__1XRLb","listWrap":"ReorderModal_listWrap__1io_5"};